import { render, staticRenderFns } from "./AnswerSection.vue?vue&type=template&id=7104f11e&scoped=true"
import script from "./AnswerSection.vue?vue&type=script&lang=js"
export * from "./AnswerSection.vue?vue&type=script&lang=js"
import style0 from "./AnswerSection.vue?vue&type=style&index=0&id=7104f11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104f11e",
  null
  
)

export default component.exports